<div class="btn-group">
  <a
    (click)="toggleKeyframes('button')"
    class="btn btn-default btn-xs"
    [class.disabled]="toggleKeyframeDisabled$ | async"
    [class.active]="selectedShapesHaveKeyLocation$ | async"
    [matTooltip]="toggleKeyframeTooltip"
  >
    <fa-icon
      [icon]="faWindowMinimize"
      [fixedWidth]="true"
      [rotate]="90"
      transform="right-7 up-1"
    ></fa-icon>
  </a>
  <button
    [matMenuTriggerFor]="menu"
    class="dropdown-toggle-split btn btn-default btn-xs"
    type="button"
  >
    <span class="caret"></span>
  </button>
  <mat-menu #menu="matMenu" xPosition="before">
    <button
      mat-menu-item
      [disabled]="copyLastKeyframeDisabled$ | async"
      (click)="copyLastKeyframe('button')"
      [matTooltip]="copyLastKeyframeTooltip"
      matTooltipPosition="below"
    >
      Copy last keyframe
    </button>
    <button
      mat-menu-item
      [disabled]="bulkRemoveKeyframeDisabled$ | async"
      (click)="bulkRemoveKeyframes('button')"
      [matTooltip]="'Bulk remove keyframes'"
    >
      Bulk Remove
    </button>
  </mat-menu>
</div>
